import styled from 'styled-components';

type WrapperProps = {
  imageSrc: string;
};

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  height: 330px;
  background-image: ${props => `url(${props.imageSrc})`};
  background-position-x: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;
`;
